const SendButton = () => {
	return (
		<div className="vtex-login-2-x-sendButton sendButton ml-auto">
			<button
				className="vtex-button bw1 ba fw5 v-mid relative pa0 lh-solid br2 min-h-small t-action--small bg-action-primary b--action-primary c-on-action-primary hover-bg-action-primary hover-b--action-primary hover-c-on-action-primary pointer "
				type="submit"
			>
				<div
					className="vtex-button__label flex items-center justify-center h-100 ph5 "
					style={{ paddingTop: '0.25em', paddingBottom: '0.32em' }}
				>
					<span className="t-small">Entrar</span>
				</div>
			</button>
		</div>
	);
};

export default SendButton;
